module.exports = __webpack_public_path__ + "img/link.737d482b.svg";